export default "__VITE_ASSET__BuvCZF_S__"